import { OptOutReasonOption } from "@Light/services/lightTypes";

/** Randomize reason order while keeping "other" last. */
export function shuffleReasons(
  reasons: OptOutReasonOption[],
): OptOutReasonOption[] {
  const other = reasons.find((reason) => reason.reason === "other");
  const rest = reasons.filter((reason) => reason.reason !== "other");

  for (let index = rest.length - 1; index > 0; index -= 1) {
    const swapIndex = Math.floor(Math.random() * (index + 1));
    [rest[index], rest[swapIndex]] = [rest[swapIndex], rest[index]];
  }

  return other ? [...rest, other] : rest;
}
